import { FC } from 'react'
import Modal from 'react-modal'
import { Capacitor } from '@capacitor/core'

import { Button } from 'components/Forms'
import { DateTime } from 'components/UI'
import { List } from 'ui'

import { t } from 'translations'

/**
 * Modal for comments history
 */

type Props = {
  comment: MData.Comment | Record<string, never>
  closeModal: () => void
  timeZone: string
}
const CommentsHistoryModal: FC<Props> = ({ comment, closeModal, timeZone }) => {
  return (
    <Modal
      isOpen={true}
      contentLabel={t('components.comments.MODAL_CONTENT_LABEL')}
      className="merinio-modal p-0"
      overlayClassName={`merinio-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-app' : ''}`}
      ariaHideApp={false}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={true}
      shouldFocusAfterRender
    >
      {/* Header with the title and close button */}
      <div className="modal-header">
        <h5 className="modal-title">{t('components.comments.EDIT_HISTORY')}</h5>
        <Button className="close" onClick={closeModal}>
          <span aria-hidden="true">&times;</span>
        </Button>
      </div>
      {/* Render the children of the modal in the body */}
      <div className="modal-body">
        <List>
          {comment.diffs.map((diff, index) => (
            <List.Item key={index}>
              {diff.created ? <small>{t('components.comments.ADDED_NEW_COMMENT')}</small> : <small>{t('components.comments.UPDATED_COMMENT')}</small>}
              <div className="text-info">
                <small>
                  <DateTime date={diff.updatedDate} isUTC timeZone={timeZone} outFormat="humanDateTime" />
                </small>
              </div>
              <span className="text-preline">{diff.text}</span>
            </List.Item>
          ))}
        </List>
        {/* Footer of the modal, close button */}
        <div className="modal-footer">
          <Button text="actions.CLOSE" className="btn btn-secondary" onClick={closeModal} />
        </div>
      </div>
    </Modal>
  )
}

export default CommentsHistoryModal
